import { useEffect, useState } from "react";
import { resolveActiveCatalogueId } from "@/lib/catalogue-selection";
import { useCatalogues } from "./use-catalogues";

/** Keep playground selection valid even while its selector tab is unmounted. */
export function useCatalogueSelection() {
  const catalogues = useCatalogues();
  const [selectedCatalogueId, setSelectedCatalogueId] = useState("");
  const activeCatalogueId = resolveActiveCatalogueId(catalogues.catalogues, selectedCatalogueId);

  useEffect(() => {
    if (catalogues.isLoading || catalogues.isError) return;
    const nextId = activeCatalogueId || "";
    if (selectedCatalogueId !== nextId) setSelectedCatalogueId(nextId);
  }, [activeCatalogueId, selectedCatalogueId, catalogues.isLoading, catalogues.isError]);

  return { ...catalogues, selectedCatalogueId, setSelectedCatalogueId, activeCatalogueId };
}
